import {
    UPDATE_STORE_TUTORIAL
} from './actionTypes';

/**
 * Event for key pressed.
 *
 * @param {Object} props - The props needed to handling key pressed on virtual keyboard.
 * @returns {{
 *     type: VIRTUAL_KEY_PRESSED,
 *     storeObj: object
 * }}
 */
export function updateStoreTutorial(storeObj) {
    return {
        type: UPDATE_STORE_TUTORIAL,
        payload: { ...storeObj }
    };
}
